import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { EntradasService } from '../../services/entradas.service';

import { Entrada } from '../../models/entrada.model';
import { mergeMap, map, takeWhile } from 'rxjs/operators';
import { of } from 'rxjs';
import { VentaService } from '../../services/venta.service';
import { Carrito } from '../../models/carrito.model';
import { ConfigurationService } from 'src/app/core';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { MotivosService } from '../../services/motivos.service';
import { MotivoPadService } from 'src/app/shared/services/motivo-pad.service';
import { StepperNavigationService } from '../../services/stepper-navigation.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NumpadService } from 'src/app/shared/services/numpad.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { LocalizadorService } from 'src/app/modules/localizador/services/localizador.service';
import { KeyboardConfigService } from 'src/app/shared/services/keyboard-config.service';

@Component({
  selector: 'ticketing-modal-selector-motivos',
  templateUrl: './modal-selector-motivos.component.html',
  styleUrls: ['./modal-selector-motivos.component.scss'],
})
export class ModalSelectorMotivosComponent implements OnInit, OnDestroy {
  entrada;
  @Input() id: string;

  private element: any;

  pager: any = {};
  pagedItems: any[];

  carrito;
  divisaSimboloDecimal: string;
  divisaSimbSeparacionMiles: string;
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  divisaSimboloDerecha: string;
  esGranDivisa: boolean;

  motivoSeleccionado;

  listaMotivosSeleccionados = [];

  motivos;

  private alive = true;
  private handleGlobalKeydownBound: (event: KeyboardEvent) => void;
  isKeyboardHidden = false;

  constructor(
    private entradaService: EntradasService,
    private modalService: ModalService,
    private ventaService: VentaService,
    private configuration: ConfigurationService,
    private numpadService: NumpadService,
    private formControlService: FormControlService,
    private motivosService: MotivosService,
    private motivoPadService: MotivoPadService,
    private stepperNavigation: StepperNavigationService,
    private el: ElementRef,
    private configurationService: ConfigurationService,
    private toast: ToastrService,
    private translate: TranslateService,
    private localizadorService: LocalizadorService,
    private keyboardConfigService: KeyboardConfigService
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit() {
    this.divisaSimbSeparacionMiles =
      this.configurationService.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal =
      this.configurationService.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configurationService.divisasValue[0].simbolo;
    this.divisaDecimales = Number(
      this.configurationService.divisasValue[0].NumeroDecimales
    );
    this.divisaPosicion =
      this.configurationService.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha =
      this.configuration.divisasValue[0].SimboloDerecha;
    
    // Agregar listener global para capturar eventos de teclado cuando el modal está abierto
    this.handleGlobalKeydownBound = this.handleGlobalKeydown.bind(this);
    document.addEventListener('keydown', this.handleGlobalKeydownBound);
    
    // Suscribirse a cambios en la configuración del teclado numérico para ajustar layout
    this.keyboardConfigService.keyboardConfig$
      .pipe(takeWhile(() => this.alive))
      .subscribe((config) => {
        this.isKeyboardHidden = config.hideNumeric;
      });
    
    // Suscribirse a cambios en el FormControl para configurar el motivo cuando sea necesario
    this.formControlService.currentFormGroup
      .pipe(takeWhile(() => this.alive))
      .subscribe((formGroup) => {
        if (formGroup && formGroup.tipo === 'MOTIVO' && formGroup.elemento) {
          // Si el tipo es MOTIVO pero motivoPadService.motivo no está configurado, intentar obtenerlo
          if (!this.motivoPadService.motivo) {
            const motivo = this.obtenerMotivoDesdeElemento(formGroup.elemento);
            if (motivo) {
              this.motivoPadService.motivo = motivo;
            }
          }
        }
      });
    this.ventaService.carrito
      .pipe(takeWhile(() => this.alive))
      .subscribe((carrito) => {
        this.carrito = carrito;
      });
    //
    this.entradaService.entradaSeleccionada$
      .pipe(
        mergeMap((entrada) => {
          // ;
          this.entrada = entrada;
          if (entrada) {
            //<< Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables

            return this.entradaService.getDescuentos(entrada.GrupoMotivoId, 1);
            // if (entrada.TipoProducto === '2') {
            //   let motivoId = 0;
            //   entrada.PromocionEntradas.forEach(element => {
            //     if (element.GrupoMotivoId != '') {
            //       motivoId = element.GrupoMotivoId;
            //     }
            //   });
            //   return this.entradaService.getDescuentos(motivoId,1); //Yaribel 20201224 Añadimos solicitar solo los seleccionables
            // } else {
            //   return this.entradaService.getDescuentos(entrada.GrupoMotivoId,1); //Yaribel 20201224 Añadimos solicitar solo los seleccionables
            // }

            // Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables >>
          } else {
            return of(entrada);
          }
        })
      )
      .pipe(
        mergeMap((res) => {
          if (this.entrada) {
            //
            return this.motivosService
              .getMotivosSeleccionadosByEntradaId(this.entrada.idTarifa)
              .pipe(
                map((motivosSeleccionados) => {
                  if (motivosSeleccionados) {
                    this.listaMotivosSeleccionados = motivosSeleccionados.lista;
                  }
                  return res;
                })
              );
          } else {
            return of(res);
          }
        })
      )
      .pipe(takeWhile(() => this.alive))
      .subscribe((motivos) => {
        //
        //
        this.motivos = motivos;
      });
    
    // Suscribirse a cambios en motivosSeleccionados para actualizar listaMotivosSeleccionados
    this.motivosService.motivosSeleccionados
      .pipe(takeWhile(() => this.alive))
      .subscribe((todosLosMotivos) => {
        if (this.entrada && todosLosMotivos && Array.isArray(todosLosMotivos)) {
          const motivosDeEstaEntrada = todosLosMotivos.find(
            m => m.idEntrada === this.entrada.idTarifa
          );
          if (motivosDeEstaEntrada && motivosDeEstaEntrada.lista) {
            this.listaMotivosSeleccionados = motivosDeEstaEntrada.lista;
          } else if (motivosDeEstaEntrada && (!motivosDeEstaEntrada.lista || motivosDeEstaEntrada.lista.length === 0)) {
            this.listaMotivosSeleccionados = [];
          } else if (!motivosDeEstaEntrada) {
            this.listaMotivosSeleccionados = [];
          }
        }
      });
    
    const modal = this;
    if (!this.id) {
      return;
    }
    document.body.appendChild(this.element);
    this.element.addEventListener('click', function (e: any) {
      if (e.target.className === 'jw-modal') {
        modal.close();
      }
    });
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.formControlService.unfocus();
    this.modalService.remove(this.id);
    this.element.remove();
    // Remover listener global
    if (this.handleGlobalKeydownBound) {
      document.removeEventListener('keydown', this.handleGlobalKeydownBound);
    }
  }

  open(): void {
    this.formControlService.unfocus();
    this.element.style.display = 'block';
    document.body.classList.add('jw-modal-open');
  }

  avanzar() {
    this.close();
  }

  getPrecioTotal() {
    return this.motivosService.getPrecioTotal();
  }

  getCantidadTotal() {
    return this.motivosService.getCantidadTotal();
  }

  close(): void {
    this.agregarMotivosLocalizador();

    if (this.modalService.isOpen('selector-mas-entradas')) {
      this.modalService.close('selector-mas-entradas');
    }
    this.formControlService.unfocus();
    this.entrada = undefined;
    this.listaMotivosSeleccionados = [];
    this.motivoSeleccionado = undefined;
    this.motivoPadService.motivo = undefined;
    this.motivoPadService.selected = undefined;
    this.element.style.display = 'none';
    this.motivos = [];
    document.body.classList.remove('jw-modal-open');
  }

  selectMotivo(motivo) {
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.entrada.idTarifa;
    // this.entrada.motivos.push(motivo);
    const input = document.getElementById(
      `motivo-${this.motivoSeleccionado.PkId}`
    );
    this.motivoPadService.selected = input;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(
      null,
      input,
      input.getAttribute('category')
    );
    if ((<HTMLElement>event.target).getAttribute('category') === 'MOTIVO') {
      this.numpadService.commaDisabled = true;
    } else {
      this.numpadService.commaDisabled = false;
    }
  }

  agregarMotivosLocalizador() {
    if (this.getCantidadTotal() > this.entrada.cantidad) {
      this.toast.error('', this.translate.instant('ERROR_MOTIVOS_CANTIDAD'), {
        toastComponent: ErrorToast,
        timeOut: 5000,
      });
      return;
    }

    let motivosArr = this.listaMotivosSeleccionados.length > 0 ? this.listaMotivosSeleccionados : [];

    this.entrada.ListaMotivos = motivosArr.length > 0
      ? motivosArr.map((motivo) => {
        return {
          MotivoId: motivo.PkId,
          Cantidad: motivo.numMotivo,
        };
      })
      : [];
    
    this.entradaService.setEntradaSeleccionada(this.entrada);
  }

  getCantidadPorMotivo(id) {
    if (this.listaMotivosSeleccionados) {
      return this.listaMotivosSeleccionados.find((m) => m.PkId === id)
        ? this.listaMotivosSeleccionados.find((m) => m.PkId === id).numMotivo
        : '';
    } else {
      return '';
    }
  }

  eliminarMotivo(motivo) {
    const oldVals = {
      motivoSeleccionado: this.motivoPadService.motivo,
      selected: this.motivoPadService.selected,
    };
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.entrada.idTarifa;
    const input = document.getElementById(
      `motivo-${this.motivoSeleccionado.PkId}`
    );
    this.motivoPadService.selected = input;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(
      null,
      input,
      input.getAttribute('category')
    );
    this.formControlService.setToBlank();

    if (oldVals.motivoSeleccionado) {
      this.motivoSeleccionado = oldVals.motivoSeleccionado;
    }
    if (oldVals.selected) {
      this.motivoPadService.selected = oldVals.selected;
    }

    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(
      null,
      this.motivoPadService.selected,
      this.motivoPadService.selected.getAttribute('category')
    );
    // this.numpadService.entrada = entradaOriginal;
  }

  focusValue(event: FocusEvent, motivo) {
    this.motivoSeleccionado = motivo;
    const target = event.target as HTMLInputElement;
    
    // Forzar el category a MOTIVO si no está configurado correctamente
    if (target.getAttribute('category') !== 'MOTIVO') {
      target.setAttribute('category', 'MOTIVO');
    }
    
    // Asegurar que el data-motivo-pk-id esté configurado
    if (!target.getAttribute('data-motivo-pk-id')) {
      target.setAttribute('data-motivo-pk-id', motivo.PkId);
    }
    
    this.motivoPadService.selected = target;
    this.motivoPadService.motivo = motivo;
    
    // Forzar el tipo a MOTIVO en setCurrentFormGroup
    this.formControlService.setCurrentFormGroup(
      null,
      target,
      'MOTIVO'
    );
  }

  // Método auxiliar para obtener el motivo desde el elemento
  private obtenerMotivoDesdeElemento(elemento: HTMLElement): any {
    const motivoPkId = elemento.getAttribute('data-motivo-pk-id');
    if (motivoPkId) {
      const motivo = this.listaMotivosSeleccionados?.find(m => m.PkId === motivoPkId);
      if (motivo) {
        return motivo;
      }
    }
    // Fallback: buscar por id
    const id = elemento.id;
    if (id && id.startsWith('motivo-')) {
      const pkId = id.replace('motivo-', '');
      return this.listaMotivosSeleccionados?.find(m => m.PkId === pkId);
    }
    return null;
  }

  unfocusValue(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.motivoPadService.setNumpadOrder('reset');
      return;
    }
  }

  onInputChange(event: Event, motivo: any) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const cantidad = value === '' || value === null || value === undefined ? 0 : parseInt(value, 10) || 0;
    
    // Actualizar el estado interno de motivos cuando cambia el input
    this.motivosService.pushMotivo(motivo, cantidad);
  }

  inputDeTeclado(event: KeyboardEvent, motivo: any) {
    event.preventDefault();
    const key = event.key;
    
    // Configurar el motivo seleccionado
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.entrada.idTarifa;
    
    const target = event.target as HTMLInputElement;
    
    // Asegurar que el category y data-motivo-pk-id estén configurados
    if (target.getAttribute('category') !== 'MOTIVO') {
      target.setAttribute('category', 'MOTIVO');
    }
    if (!target.getAttribute('data-motivo-pk-id')) {
      target.setAttribute('data-motivo-pk-id', motivo.PkId);
    }
    
    // Configurar motivoPadService
    this.motivoPadService.selected = target;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    
    // Configurar FormControl
    this.formControlService.setCurrentFormGroup(
      null,
      target,
      'MOTIVO'
    );
    
    // Manejar teclas especiales
    if (this.isDeleteButtonPressed(key)) {
      this.formControlService.deleteChar();
      return;
    }
    
    if (this.isEnterButton(key)) {
      this.formControlService.unfocus();
      target.blur();
      return;
    }
    
    // Manejar números
    if (this.isNumberKey(key)) {
      this.formControlService.inputChar(key);
      return;
    }
  }

  isNumberKey(key: string): boolean {
    return /^[0-9]$/.test(key); // Acepta '0' a '9' desde cualquier fuente
  }

  isDeleteButtonPressed(key: string): boolean {
    return key === 'Backspace';
  }

  isEnterButton(key: string): boolean {
    return key === 'Enter';
  }

  handleGlobalKeydown(event: KeyboardEvent) {
    // Solo procesar si el modal está abierto y visible
    if (this.element && this.element.style.display === 'block') {
      // Si el target no es un input, intentar procesar el evento del teclado numérico
      if ((event.target as HTMLElement)?.tagName !== 'INPUT') {
        // Detectar si es una tecla del teclado numérico usando code (más confiable que key)
        const numpadKey = this.getNumpadKeyFromCode(event.code);
        if (numpadKey !== null) {
          event.preventDefault();
          event.stopPropagation();
          
          // Buscar el input activo o el primer motivo disponible
          const activeInput = document.activeElement as HTMLInputElement;
          
          if (activeInput && activeInput.tagName === 'INPUT' && activeInput.closest('.MotivosModalLayout')) {
            // Usar input activo
          } else {
            // Buscar el primer input de motivo disponible
            const modalMotivos = document.querySelector('.MotivosModalLayout') as HTMLElement;
            if (modalMotivos) {
              // Prioridad 1: Usar motivoSeleccionado (el motivo visualmente seleccionado)
              if (this.motivoSeleccionado && this.motivoSeleccionado.PkId) {
                this.motivoSeleccionado.idEntradaAsociada = this.entrada.idTarifa;
                const input = document.getElementById(`motivo-${this.motivoSeleccionado.PkId}`);
                
                if (input) {
                  this.motivoPadService.selected = input;
                  this.motivoPadService.motivo = this.motivoSeleccionado;
                  this.formControlService.setCurrentFormGroup(
                    null,
                    input,
                    input.getAttribute('category')
                  );
                  this.formControlService.inputChar(numpadKey);
                }
              } 
              // Prioridad 2: Usar motivoPadService.motivo si existe
              else if (this.motivoPadService.motivo && this.motivoPadService.motivo.PkId) {
                let targetInput = modalMotivos.querySelector(`input#motivo-${this.motivoPadService.motivo.PkId}`) as HTMLInputElement;
                if (!targetInput) {
                  targetInput = modalMotivos.querySelector(`input#motivo-input-${this.motivoPadService.motivo.PkId}`) as HTMLInputElement;
                }
                
                if (targetInput) {
                  this.motivoPadService.selected = targetInput;
                  this.formControlService.setCurrentFormGroup(null, targetInput, 'MOTIVO');
                  this.formControlService.inputChar(numpadKey);
                }
              }
              // Prioridad 3: Seleccionar automáticamente el primer motivo
              else if (this.motivos && this.motivos.length > 0) {
                const primerMotivo = this.motivos[0];
                
                this.motivoSeleccionado = primerMotivo;
                this.motivoSeleccionado.idEntradaAsociada = this.entrada.idTarifa;
                const input = document.getElementById(`motivo-${this.motivoSeleccionado.PkId}`);
                
                if (input) {
                  this.motivoPadService.selected = input;
                  this.motivoPadService.motivo = this.motivoSeleccionado;
                  this.formControlService.setCurrentFormGroup(
                    null,
                    input,
                    input.getAttribute('category')
                  );
                  this.formControlService.inputChar(numpadKey);
                }
              }
            }
          }
        }
      }
    }
  }

  getNumpadKeyFromCode(code: string): string | null {
    // Mapear códigos del teclado numérico a números
    const numpadMap: { [key: string]: string } = {
      'Numpad0': '0',
      'Numpad1': '1',
      'Numpad2': '2',
      'Numpad3': '3',
      'Numpad4': '4',
      'Numpad5': '5',
      'Numpad6': '6',
      'Numpad7': '7',
      'Numpad8': '8',
      'Numpad9': '9',
      'NumpadDecimal': ',',
      'NumpadEnter': 'Enter',
      'NumpadAdd': '+',
      'NumpadSubtract': '-',
      'NumpadMultiply': '*',
      'NumpadDivide': '/'
    };
    
    return numpadMap[code] || null;
  }
}
